import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { View } from "react-native-ui-lib";
import { CartItemRootParmList, RegisterRootParamList } from "../../../../types";
import { EditCartItemModalScreen } from "../EditCartItemModalScreen";
import { ActiveCartItemContext } from "./context";
import { Database } from "@nozbe/watermelondb";
import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { compose } from "recompose";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import SaleItem from "../../../../utilities/data/model/SaleItem";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { DiscountCartItemModalScreen } from "../DiscountCartItemModalScreen";
import { EditSerialNumberScreen } from "../EditSerialNumberScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { EditProductRootScreen } from "../../../products/screens";
import { EditCartItemNoteScreen } from "../EditCartItemNoteScreen";
import { useCurrentVendorProvider } from "../../../../utilities/vendor";
import { vendorCanAccessFeature } from "../../../../utilities/feature-flags";
import { AccountFeatureFlag } from "@towersystems/roam-common/lib/generated-types";
import { ProductAiInsightsRootModalScreen } from "../ProductAiInsightsScreens";

const getObserables = ({
  route,
  database,
}: {
  route: any;
  database: Database;
}) => {
  return {
    item: database
      .get<SaleItem>("sale_items")
      .findAndObserve(route.params.lineItemId),
  };
};

interface CartItemModalRootScreenProps
  extends ExtractedObservables<ReturnType<typeof getObserables>>,
    NativeStackScreenProps<RegisterRootParamList, "CartItemModalRootScreen"> {}

export const CartItemModalRootScreenRenderer = ({
  item,
}: CartItemModalRootScreenProps) => {
  const Stack = createStackHeaderNavigator<CartItemRootParmList>();
  const { currentVendor } = useCurrentVendorProvider();

  if (!item) {
    return <View />;
  }

  return (
    <ActiveCartItemContext.Provider value={{ item }}>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          title: "",
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen
          name="EditCartItemModalScreen"
          component={EditCartItemModalScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        />
        <Stack.Screen
          name="EditCartItemNoteScreen"
          component={EditCartItemNoteScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
        <Stack.Screen
          name="DiscountCartItemModalScreen"
          component={DiscountCartItemModalScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
        <Stack.Screen
          name="EditSerialNumberScreen"
          component={EditSerialNumberScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
        {vendorCanAccessFeature(
          AccountFeatureFlag.POS_APP_MANAGE_PRODUCTS_UI,
          currentVendor
        ) && (
          <Stack.Group
            screenOptions={{
              headerShown: false,
            }}
          >
            <Stack.Screen
              name="EditProductRootScreen"
              component={EditProductRootScreen}
            />
          </Stack.Group>
        )}
        <Stack.Group
          screenOptions={{
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="ProductAiInsightsRootModalScreen"
            component={ProductAiInsightsRootModalScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ActiveCartItemContext.Provider>
  );
};
export const CartItemModalRootScreen = compose(
  withDatabase,
  withObservables(["route"], getObserables)
  // @ts-ignore
)(CartItemModalRootScreenRenderer);
